// extracted by mini-css-extract-plugin
export var brand = "_38-9";
export var compact = "_38-6";
export var extraSmall = "_38-7";
export var icon = "_38-0";
export var large = "_38-4";
export var light = "_38-1";
export var medium = "_38-5";
export var outline = "_38-b";
export var primaryDark = "_38-a";
export var primaryLight = "_38-8";
export var primaryModern = "_38-c";
export var success = "_38-2";
export var successSolid = "_38-3";